<template>
  <v-dialog
    v-model="processDialog"
    width="540"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('withdrawals.withdrawals') }}</b>
      </v-card-title>
      
      <v-card-text
        class="mt-5"
      >
        {{ $t('withdrawals.automationNetwork') }}<br>
        <v-select
          v-model="form.network"
          :items="networkList"
          :item-text="'name'"
          :item-value="'value'"
          :label="$t('withdrawals.selectNetwork') + '*'"
          :error-messages="NetworkErrors"
          @input="$v.form.network.$touch()"
          @blur="$v.form.network.$touch()"
        />
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="processDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || ($v.$invalid)"
          :loading="loading"
          @click="activate()"
        >
          {{ $t('withdrawals.activateButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CPAY_CREATE_WITHDRAWALS_WALLET from "@/graphql/mutations/CPayCreateWithdrawalsWallet.gql"


import { validationMixin } from "vuelidate"
import {
  required,
} from "vuelidate/lib/validators"

export default {
  name: "ProcessDialog",
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    whitelabelUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      wallet_copied: false,
      amount_copied: false,
      loading: false,
      networkList: [
        { name: 'Tron', value: "tron" },
        { name: 'Ethereum', value: "ethereum" },
      ], // ethereum,tron,bsc,polygon
      form: {
        network: null,
      }
    };
  },
  validations() {
    return {
      form: {
        network: {
          required,
        }
      },
    };
  },
  computed: {
    processDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeAutomationDialog', false);
      }
    },
    NetworkErrors() {
      const errors = [];
      if (!this.$v.form.network.$dirty) return errors;
      !this.$v.form.network.required && errors.push(this.$t("projects.reqField"));
      return errors;
    }
  },
  methods: {
    activate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      }
      this.loading = true;
      this.form.whitelabel_uuid = this.whitelabelUuid;
      this.$apollo
        .mutate({
          mutation: CPAY_CREATE_WITHDRAWALS_WALLET,
          variables: this.form
        })
        .then(data => {
          this.loading = false;
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.processDialog = false
          this.$parent.$apollo.queries.whiteLabelWithdrawals.refetch();
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" >
</style>
